import React from 'react';
import { createRoot } from 'react-dom/client';
import Components from './Components';
import { RootContext } from './Context/RootContext';
import ContextConfiguration from './Context/ContextConfiguration';
const COMPONENTS = Object.assign({}, Components /*...AdditionalComponents*/);
function renderComponentInElement(el) {
    const App = COMPONENTS[el.dataset.reactComponent] || false;
    if (!App)
        return;
    const root = createRoot(el);
    const props = Object.assign({}, el.dataset);
    root.render(React.createElement(RootContext.Provider, { value: ContextConfiguration({
            rawAuthConfig: props === null || props === void 0 ? void 0 : props.auth,
            rawPluginConfig: props === null || props === void 0 ? void 0 : props.plugin,
            rawPageConfig: props === null || props === void 0 ? void 0 : props.page,
            assetPaths: props === null || props === void 0 ? void 0 : props.assetPaths,
        }) },
        React.createElement(App, Object.assign({}, props, { root: el }))));
}
//Load translations globally
window.ZigTranslations = [];
document.querySelectorAll('script[type=translations]').forEach((tag) => {
    const json = tag.innerHTML.trim();
    if (json) {
        const data = JSON.parse(json);
        window.ZigTranslations = Object.assign(Object.assign({}, window.ZigTranslations), data);
    }
});
document.querySelectorAll('[data-react-component]').forEach((el) => renderComponentInElement(el));
